module.exports = __webpack_public_path__ + "static/media/benedict-3.8b32f6a2.jpg";